export const ENDPOINTS = {
  getCards: 'cards/get',
  delete: 'card/delete',
  check: 'card/check-state',
};
